module.exports = __WEBPACK_EXTERNAL_MODULE_338__;


//////////////////
// WEBPACK FOOTER
// external {"root":["Rx","Observable","prototype"],"commonjs":"rxjs/operator/filter","commonjs2":"rxjs/operator/filter","amd":"rxjs/operator/filter"}
// module id = 338
// module chunks = 0 1